module.exports = __webpack_public_path__ + "Lennix-0f4eaaaa.png";